var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoAws = function SvgLogoAws(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 64,
    fill: "none",
    viewBox: "0 0 56 64"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "AWS")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CA9D",
    d: "m56 43.596-27.99-4.112L.002 43.601l28 10.377L56 43.596Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B612C",
    d: "m5.605 43.116 4.732 1.479.43-.49V11l-.43-.566-4.732 1.81v30.873Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "m27.09 41.653-16.752 2.942v-34.16l16.751 3.767v27.451Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B612C",
    d: "m19.62 47.442-6.528-2.013V3.265L19.62.001l.571.622v46.123l-.571.696Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "M41.992 42.194 19.62 47.442V0l22.373 8.72v33.474Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B612C",
    d: "M27.993 53.529.002 43.6v5.758l27.991 13.996v-9.826Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "M55.998 49.352 27.992 63.355v-9.826l28.006-9.933v5.757Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CA9D",
    d: "M48.131 34.056h-6.787l-19.346 1.318 6 1.106 20.133-2.424Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B612C",
    d: "m21.998 48.102 5.998 1.8.173-.186-.006-13.529-.172-.166-5.993-.647v12.728Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#759C3E",
    d: "m48.132 34.056-20.14 1.964.005 13.882 20.135-6.062v-9.784Z"
  })));
};
export default SvgLogoAws;